import { useLang } from '../i18n/context';
import SEO from '../components/SEO';
import { Container, Reveal } from '../components/Reveal';
import { breadcrumbSchema } from '../lib/schema';

export default function LegalPage({ mode = 'privacy' }) {
    const { t, lang } = useLang();
    const c = mode === 'privacy' ? t.privacy : t.disclaimer;
    const path = mode === 'privacy' ? '/privacy' : '/disclaimer';
    return (
        <>
            <SEO
                title={c.metaTitle}
                description={c.metaDesc}
                path={path}
                lang={lang}
                jsonLd={[breadcrumbSchema(lang, [{ name: t.nav.home, path: '/' }, { name: c.title, path }])]}
            />
            <section className="pt-28 md:pt-36" data-testid={`legal-${mode}`}>
                <Container>
                    <div className="mx-auto max-w-3xl">
                        <Reveal>
                            <h1 className="font-serif text-4xl font-semibold tracking-tight text-ink md:text-5xl">{c.title}</h1>
                            <p className="mt-4 text-sm text-ink-subtle">{c.updated}</p>
                        </Reveal>
                        <div className="mt-10 space-y-8">
                            {c.sections.map((s, i) => (
                                <Reveal key={s.h} delay={Math.min(i * 0.04, 0.2)}>
                                    <h2 className="font-serif text-xl font-semibold text-ink md:text-2xl">{s.h}</h2>
                                    <p className="mt-3 text-[15px] leading-relaxed text-ink-body">{s.p}</p>
                                </Reveal>
                            ))}
                        </div>
                    </div>
                </Container>
            </section>
            <div className="py-20" />
        </>
    );
}
